import { apiService } from '@/api/apiService';
import { ApiResponseType, AuthResponseType } from '@/types/sharedTypes';

export type CreateUnauthorizedOrganizationPayloadType = {
  recaptcha_response: string;
  user: {
    email: string;
    first_name: string;
    middle_name?: string;
    last_name: string;
  };
  organization: {
    name: string;
  };
};

export type CreateUnauthorizedOrganizationResponseType = AuthResponseType;

export const createUnauthorizedOrganizationApi = async (
  data: CreateUnauthorizedOrganizationPayloadType
): Promise<ApiResponseType<CreateUnauthorizedOrganizationResponseType>> => {
  const uri = '/organization/unauthorized/organization:create/';

  return apiService.POST(uri, data);
};
